// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import PriceResourceViewModel from '../../../../viewModel/resource/PriceResourceViewModel';
import PriceResourceDTO from '../../dto/resource/PriceResourceDTO';

export default abstract class PriceResourceModel extends BaseModel<PriceResourceDTO> {
  /**
  */
  get priceType() { return this.dto.priceType; }
  set priceType(value) { this.dto.priceType = value; }
  /**
  * @type {double}
  */
  get netPrice() { return this.dto.netPrice; }
  set netPrice(value) { this.dto.netPrice = value; }
  /**
  * @type {double}
  */
  get vatRate() { return this.dto.vatRate; }
  set vatRate(value) { this.dto.vatRate = value; }
  /**
  * @type {double}
  */
  get vatAmount() { return this.dto.vatAmount; }
  /**
  * @type {double}
  */
  get grossPrice() { return this.dto.grossPrice; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.priceType = qs.pricetype;
    value = Number.parseFloat(qs.netprice);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.netPrice = value;
    value = Number.parseFloat(qs.vatrate);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.vatRate = value;
  }
}
